import { requiredValidator, minLengthValidator } from '@src/scripts/validators'
import { date } from './defaultData'
import dayjs from 'dayjs'

export const DefaultPOAData = (options) => {
  const configuration = {
    firstName: {
      label: 'POAFirstName',
      minLength: 2,
      oneLine: true,
      validations: [required, minLength]
    },
    lastName: {
      label: 'POALastName',
      minLength: 2,
      oneLine: true,
      validations: [required, minLength]
    },
    street: {
      label: 'POAStreet',
      minLength: 2,
      oneLine: true,
      validations: [required, minLength]
    },
    city: {
      label: 'POACity',
      minLength: 2,
      oneLine: true,
      validations: [required, minLength]
    },
    parish: {
      label: 'POAParish',
      minLength: 2,
      oneLine: true,
      validations: [minLength]
    },
    state: {
      label: 'POAState',
      minLength: 2,
      oneLine: true,
      validations: [minLength]
    },
    postalCode: {
      label: 'POAPostalCode',
      minLength: 2,
      oneLine: true,
      validations: [minLength]
    },
    country: {
      label: 'POACountry',
      keyValueDropdown: true,
      hasSearch: true,
      translate: true,
      options: options.countryOptions,
      oneLine: true,
      maxLength: 3,
      validations: [],
      errorName: 'ErrorUnknownCountry'
    },
    issueDate: {
      label: 'POAIssueDate',
      placeholder: 'yyyy-mm-dd',
      maxLength: 10,
      datePicker: true,
      validations: [date, dateOfIssue]
    }
  }

  return configuration
}

function required(item) {
  return requiredValidator(item.value)
}

function minLength(item) {
  return minLengthValidator(item.value, item.minLength)
}

function dateOfIssue(item) {
  const value = item.value

  if (!dayjs(value, 'YYYY-MM-DD').isValid()) {
    return null
  }

  if (dayjs(value, 'YYYY-MM-DD').isAfter(dayjs())) {
    return 'ErrorFieldBadDate'
  }

  return null
}
